import { REACT_APP_ENVIRONMENT } from '@/config';
import type { ServiceProfile } from '@/profile/type';
import { getSubdomain } from '@/utils';

const subdomain = getSubdomain();

export const serviceProfile: ServiceProfile = await import(
  `@/profile/${REACT_APP_ENVIRONMENT}/${subdomain}.json`
).catch((e) => {
  // このCatchブロックは必須です。
  console.error('サポート対象外のプロファイルです。', e);
});
